/* Add preset mixes without navigating away from the page. */
(() => {
  if (customElements.get('pf-preset-mixes')) return;
  customElements.define('pf-preset-mixes', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('submit', (event) => this.add(event));
    }

    async add(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      event.preventDefault();
      if (form.dataset.busy === 'true') return;
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[data-pf-mix-status]');
      const label = button.textContent;
      const arabic = document.documentElement.lang.startsWith('ar');
      const failure = arabic ? 'تعذرت الإضافة. حاول مرة تانية.' : 'Could not add this mix. Please try again.';
      const drawer = document.querySelector('cart-drawer');
      const body = new FormData(form);
      body.append('sections', 'cart-drawer,cart-icon-bubble');
      body.append('sections_url', window.location.pathname);
      form.dataset.busy = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = arabic ? 'جاري الإضافة…' : 'Adding…';
      status.hidden = true;
      drawer?.setActiveElement(button);
      try {
        const response = await fetch(`${form.action.replace(/\/$/, '')}.js`, {
          method: 'POST', headers: { Accept: 'application/json' }, body,
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || failure);
        }
        status.textContent = arabic ? 'تمت إضافة الميكس للسلة ✓' : 'Mix added to cart ✓';
        status.hidden = false;
        if (drawer && data.sections?.['cart-drawer'] && data.sections?.['cart-icon-bubble']) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: data.items?.[0]?.id, sections: data.sections });
        } else if (data.sections?.['cart-icon-bubble']) {
          const parsed = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          const bubble = document.querySelector('#cart-icon-bubble');
          if (bubble) bubble.innerHTML = parsed.querySelector('.shopify-section')?.innerHTML || parsed.body.innerHTML;
        }
      } catch (error) {
        status.textContent = error.message || failure;
        status.hidden = false;
      } finally {
        delete form.dataset.busy;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = label;
      }
    }
  });
})();
